import axios from "axios";
import { useMutation } from "react-query";
import { config } from "../../utils/conf";
import { requestHeaders } from "../../utils/http";
import useSession from "../Auth/useSession";

export default function useSubmitNewUserRequest(options = {}) {
  const { accessToken } = useSession();

  const mutation = useMutation(
    (data) =>
      axios.post(`${config.communicationApiUrl}/v1/new-user-requests`, data, {
        headers: requestHeaders(accessToken),
      }),
    {
      ...options,
    },
  );

  return {
    submitNewUserRequest: mutation.mutateAsync,
    submitNewUserRequestStatus: mutation,
  };
}
